import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => {
  const pageBackground = theme.palette.grey[400];
  const cellBase = {
    height: "52px !important",
    padding: "0 12px !important",
    boxSizing: "border-box" as const,
    border: "none !important",
    borderBottom: `1px solid ${theme.palette.divider} !important`,
    fontFamily: "Noto Sans Hebrew !important",
    fontSize: "14px !important",
    lineHeight: "21px !important",
    textAlign: "right !important" as "right",
  };

  return {
    root: {
      width: "100%",
      backgroundColor: pageBackground,
      borderRadius: "6px",
      border: `1px solid ${theme.palette.divider}`,
      "& > .MuiPaper-root": {
        width: "100%",
        backgroundColor: "transparent",
      },
      "& .MuiTableContainer-root": {
        width: "100%",
        overflowX: "auto",
        overflowY: "hidden",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
      },
      "& .MuiTable-root": {
        width: "100%",
        tableLayout: "fixed",
        borderCollapse: "collapse",
        backgroundColor: `${pageBackground} !important`,
      },
      "& .MuiTableCell-root": {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
      "& .MuiTableHead-root .MuiTableCell-head, & [class*='cellHead']": {
        ...cellBase,
        fontWeight: "500 !important",
        backgroundColor: `${pageBackground} !important`,
        color: `${theme.palette.text.primary} !important`,
      },
      "& .MuiTableBody-root .MuiTableRow-root": {
        height: "52px",
        backgroundColor: `${theme.palette.background.paper} !important`,
        "&:hover, &:hover .MuiTableCell-root": {
          backgroundColor: `${theme.palette.background.tableRowHover} !important`,
        },
      },
      "& .MuiTableBody-root .MuiTableCell-root": {
        ...cellBase,
        fontWeight: "400 !important",
        backgroundColor: `${theme.palette.background.paper} !important`,
        color: `${theme.palette.secondary.main} !important`,
      },
      "& .MuiTableHead-root .MuiTableCell-head:nth-child(1), & .MuiTableBody-root .MuiTableCell-root:nth-child(1), & .MuiTableHead-root .MuiTableCell-head:nth-child(4), & .MuiTableBody-root .MuiTableCell-root:nth-child(4)":
        {
          width: "48px !important",
        },
      "& .MuiTableHead-root .MuiTableCell-head:nth-child(2), & .MuiTableBody-root .MuiTableCell-root:nth-child(2)":
        {
          textAlign: "center !important" as "center",
        },
      "& .MuiTableHead-root .MuiTableCell-head:nth-child(3), & .MuiTableBody-root .MuiTableCell-root:nth-child(3)":
        {
          width: "180px !important",
        },
    },
    menuButton: {
      padding: "0 !important",
    },
    priorityCell: {
      display: "inline-flex",
      justifyContent: "center",
      width: "100%",
    },
  };
});
